import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
const Footer = () => {
    return (


        <div className="footerreflexo">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="footer__cta">
                            <div className="text-light footer__cta_content"><span>Des questions sur la Réflexologie ?</span><h2 className="mb-0">
                                Contactez-moi.</h2></div>

                            <div className="footer__cta_action"><a className="btn btn-light btn-zoom" href="/contact">Me Contacter</a>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row footer__widget"><div className="col-lg-4">
                    <div className="footer__widget_logo mb-5"><img className="imgfooter" src="assets/img/Logo-NiveRama-Reflexologue-symbole.png" alt="widget-logo" /></div>
                </div>

                    <div className="col-lg-4">
                        <div className="text-light footer__widget_sitemap mb-5">

                            <h4 className="base-font">Plan du site</h4>
                            <ul className="unstyle-list small">
                                <li className="mb-2"><a className="text-light" href="/">Accueil</a></li>
                                <li className="mb-2"><a className="text-light" href="/apropos">A propos</a></li>
                                <li className="mb-2"><a className="text-light" href="/reflexologie">La Réflexologie</a></li>
                                <li className="mb-2"><a className="text-light" href="/tarifs">Tarifs</a></li>

                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="text-light footer__widget_address mb-5">
                            <h4 className="base-font">Address</h4>
                            <p className="social-container">
                                <a href="tel:+33622111569" ><FontAwesomeIcon icon={faPhone} size="2x" />+33 6 22 11 15 69</a>
                                <br></br>
                                <a href="mailto:nive.ramarovelo.reflexologue@gmail.com"><FontAwesomeIcon icon={faEnvelope} size="2x" /> nive.ramarovelo.reflexologue@gmail.com</a>
                                <br></br>
                                <a href="https://www.instagram.com/niveramarovelo/"><FontAwesomeIcon icon={faInstagram} size="2x" /> Instagram</a>
                                <br></br>
                                <a href="https://www.annuaire-therapeutes.com/therapeute/166472-nive-ramarovelo-paris-10"><FontAwesomeIcon icon={faGlobe} size="2x" /> annuaire-therapeutes</a>
                                <br></br>
                            </p>
                        </div></div></div>

            </div>
        </div>

    )
}

export default Footer